import { call, cancel, select, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalAction,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
  ProduktRequested,
} from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';
import { VwgActions } from '../vwgActions';
import { ExtremeWetterschutzSelbstbeteiligungValues } from '../models/ExtremWetterschutzSelbstbeteiligungValues.model';

export enum EXTREME_SB_REQUEST_EVENTS {
  REQUEST_SUCCESSFULL = 'REQUEST_SUCCESSFULL',
  REQUEST_FAILED = 'REQUEST_FAILED',
}

export function* extremWetterschutzSelbstbeteiligungSaga() {
  yield takeEvery(GlobalActions.PRODUKT_REQUESTED, safeSaga(getExtremSelbstbeteiligungValues, App.VWG_V2));
  yield takeEvery(GlobalActions.PRODUKT_REQUESTED_AFTER_SAVE, safeSaga(getExtremSelbstbeteiligungValues, App.VWG_V2));
  yield takeEvery(
    EXTREME_SB_REQUEST_EVENTS.REQUEST_SUCCESSFULL,
    safeSaga(successCallback, App.VWG_V2),
  );
}

export function* getExtremSelbstbeteiligungValues(action: GlobalAction<ProduktRequested>) {
  if (action.payload.appId === App.VWG_V2) {
    yield extremWetterSchutzSelbstbeteiligungValuesRequest(action);
  } else {
    yield cancel();
  }
}

export function* extremWetterSchutzSelbstbeteiligungValuesRequest(
  action: GlobalAction<ProduktRequested>,
) {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();

  if (action.payload.appId === App.VWG_V2 && action.payload.angebotsId === state.angebotsId) {
    yield call(
      globalPut.put.bind(globalPut),
      new GlobalActions().doRequest({
        appId: App.VWG_V2,
        angebotsId: action.payload.angebotsId,
        method: HTTP_METHOD.GET,
        url: 'privatschutz/api/extremwetterschutzselbstbeteiligung',
        successEvent: EXTREME_SB_REQUEST_EVENTS.REQUEST_SUCCESSFULL,
        errorEvent: EXTREME_SB_REQUEST_EVENTS.REQUEST_FAILED,
      }),
    );
  } else {
    yield cancel();
  }
}

export function* successCallback(
  successAction: DoRequestResponse<ExtremeWetterschutzSelbstbeteiligungValues[]>,
) {
  const state: IAppState = yield select();

  if (
    successAction.doRequestAction.payload.appId === App.VWG_V2 &&
    successAction.doRequestAction.payload.angebotsId === state.angebotsId
  ) {
    const globalPut = GlobalPut.getInstance();
    yield call(
      globalPut.put,
      new VwgActions().extremWetterschutzSelbstbeteiligungReceived(
        successAction.payload,
        successAction.doRequestAction.payload.angebotsId,
      ),
    );
  }
}
